// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".channels-tabs[data-v-35d6e924]{color:#1d2023;padding:32px 0 64px}.channels-tabs h2[data-v-35d6e924]{font-family:\"MTS Wide\",MTSWide,Arial,sans-serif;font-size:36px;font-weight:500;letter-spacing:-.01em;line-height:40px;margin-bottom:20px}@media(max-width:767px){.channels-tabs h2[data-v-35d6e924]{font-size:32px;line-height:38px;max-width:400px}}.channels-tabs[data-v-35d6e924] .v-tabs-mts{margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
